// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__YOvWG","copy":"Footer_copy__Sloa+"};